import { Logger, select, selectAll } from "@fruugo/utilities";
import { getHomepageHeroData } from "./api";
import { createPictureElement } from "./utilities";
import { HomepageContentItem } from "../types";
import Glide, { Controls, Swipe } from "@glidejs/glide/dist/glide.modular.esm";
import { heroImagesSizes, imageFormats } from "../config";

const Log = new Logger(window.environment);

export default function initHomeBanner() {
  const banner = select<HTMLElement>("#cms-hero");
  if (!banner) return;

  getHomepageHeroData(heroImagesSizes.join(","), imageFormats.join(","))
    .then((data) => {
      if (data.theme === null || data.items === null) return;
      updateBanner(banner, data.items);
      initBannersHero(banner);
    })
    .catch((error) => Log.error(error));
}

function updateBanner(banner: HTMLElement, banners: HomepageContentItem[]) {
  const wrapper = banner.querySelector(".glide__slides");
  const template = banner.querySelector(".glide__slide");
  if (!wrapper || !template) return;
  banners.slice(0, 5).forEach((banner, index) => {
    const slide = createHero(banner, template.cloneNode(true), index === 0);
    wrapper?.appendChild(slide);
  });
  template?.remove();
}

function createHero(
  item: HomepageContentItem,
  template: Node,
  prioritiseImage: boolean
) {
  const element = template as Element;

  const inner = element.querySelector(".Home__Hero__ItemInner");
  const title = element.querySelector(".Home__Hero__ItemInner__Title");
  const description = element.querySelector("p");
  const hidden = element.querySelector(".d-none");

  if (inner) inner.classList.remove("bg-transparent");

  const picture = createPictureElement(
    item.imageUrl,
    item.imageSizes,
    item.title,
    "Home__Hero__Item__Image",
    true
  );
  if (prioritiseImage) {
    picture.querySelector("img")?.setAttribute("fetchpriority", "high");
  }
  element.appendChild(picture);

  if (title) title.textContent = item.title;
  if (description) description.textContent = item.subtitle;
  if (hidden) hidden.classList.remove("d-none");

  element.setAttribute("href", item.cta.href);
  return element;
}

function initBannersHero(banner: HTMLElement) {
  showArrows();
  return new Glide(banner, {
    type: "carousel",
    perView: 1,
    animationDuration: 600,
    direction: window.rtl ? "rtl" : "ltr",
    gap: 0,
    dragThreshold: false,
  }).mount({ Controls, Swipe });
}

function showArrows() {
  const arrows = selectAll("#cms-hero .glide__arrow");
  if (arrows && arrows.length > 0) {
    arrows.forEach((arrow) => arrow.classList.add("d-lg-block"));
  }
}
